import { useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import "../Home/AppHome.css";
import "../Admin/Admin.css";
import Header2 from "./Header2";

export default function NewMemberHome() {
  const navigate = useNavigate();

  useEffect(() => {
    const role = sessionStorage.getItem("userRole");

    if (!role) {
      navigate("/");
    }
  }, [navigate]);

  return (
    <div className="dashboard">
      <Header2 />

      <div className="welcome-container">
        <div className="button-container">

          <button
            className="big-btn"
            onClick={() => navigate("/assis/registration_KB")}
          >
            📝 Register Form [Kesbewa]
          </button>

          <button
            className="big-btn blue"
            onClick={() => navigate("/assis/registration_WB")}
          >
            📝 Register Form [Werahera]
          </button>

        </div>
      </div>
    </div>
  );
}